export enum ChatRole  {
    USER = 'USER',
    SYSTEM = 'SYSTEM',
    ASSISTANT = 'ASSISTANT',
    AI_RESPONSE = 'AI_RESPONSE'
}
export enum ChatMessageTypeModel {
    BASIC = 'BASIC',
    CONTENT_GENERATION = 'CONTENT_GENERATION',
    HEADLINE_GENERATION = 'HEADLINE_GENERATION',
    QUICK_DISTRIBUTION = 'QUICK_DISTRIBUTION',
    QUICK_DISTRIBUTION_REGENERATION = 'QUICK_DISTRIBUTION_REGENERATION',
    MENTION_INSIGHTS = 'MENTION_INSIGHTS',
    PUBLIC_BRIEFING_MENTION_INSIGHTS = 'PUBLIC_BRIEFING_MENTION_INSIGHTS',
    CONTENT_REFINEMENT = 'CONTENT_REFINEMENT'
}

// This matches B.E format enums
export enum QuickDistributionFormat {
    QUICK_DISTRIBUTION_PRESSRELEASE = 'QUICK_DISTRIBUTION_PRESSRELEASE',
    QUICK_DISTRIBUTION_PRESSRELEASE_SUBJECTLINE = 'QUICK_DISTRIBUTION_PRESSRELEASE_SUBJECTLINE',
    QUICK_DISTRIBUTION_PRESSRELEASE_PREVIEWTEXT = 'QUICK_DISTRIBUTION_PRESSRELEASE_PREVIEWTEXT',
    QUICK_DISTRIBUTION_PRESSRELEASE_HEADLINE = 'QUICK_DISTRIBUTION_PRESSRELEASE_HEADLINE',
    QUICK_DISTRIBUTION_PRESSRELEASE_SUBHEADLINE = 'QUICK_DISTRIBUTION_PRESSRELEASE_SUBHEADLINE',
    QUICK_DISTRIBUTION_PRESSRELEASE_MARKETINGPITCH = 'QUICK_DISTRIBUTION_PRESSRELEASE_MARKETINGPITCH',
    QUICK_DISTRIBUTION_PRESSRELEASE_BODY = 'QUICK_DISTRIBUTION_PRESSRELEASE_BODY',
    QUICK_DISTRIBUTION_PRESSRELEASE_MARKETING_CONCLUSION = 'QUICK_DISTRIBUTION_PRESSRELEASE_MARKETING_CONCLUSION',
    QUICK_DISTRIBUTION_PRESSRELEASE_ABOUTUS = 'QUICK_DISTRIBUTION_PRESSRELEASE_ABOUTUS',
    QUICK_DISTRIBUTION_PRESSRELEASE_CONTACTUS = 'QUICK_DISTRIBUTION_PRESSRELEASE_CONTACTUS',

    QUICK_DISTRIBUTION_EMAIL = 'QUICK_DISTRIBUTION_EMAIL',
    QUICK_DISTRIBUTION_EMAIL_SUBJECTLINE = 'QUICK_DISTRIBUTION_EMAIL_SUBJECTLINE',
    QUICK_DISTRIBUTION_EMAIL_PREVIEWTEXT = 'QUICK_DISTRIBUTION_EMAIL_PREVIEWTEXT',
    QUICK_DISTRIBUTION_EMAIL_HEADLINE = 'QUICK_DISTRIBUTION_EMAIL_HEADLINE',
    QUICK_DISTRIBUTION_EMAIL_SUBHEADLINE = 'QUICK_DISTRIBUTION_EMAIL_SUBHEADLINE',
    QUICK_DISTRIBUTION_EMAIL_MARKETINGPITCH = 'QUICK_DISTRIBUTION_EMAIL_MARKETINGPITCH',
    QUICK_DISTRIBUTION_EMAIL_BODY = 'QUICK_DISTRIBUTION_EMAIL_BODY',
    QUICK_DISTRIBUTION_EMAIL_MARKETING_CONCLUSION = 'QUICK_DISTRIBUTION_EMAIL_MARKETING_CONCLUSION',
    QUICK_DISTRIBUTION_EMAIL_ABOUTUS = 'QUICK_DISTRIBUTION_EMAIL_ABOUTUS',
    QUICK_DISTRIBUTION_EMAIL_CONTACTUS = 'QUICK_DISTRIBUTION_EMAIL_CONTACTUS'
}
